module.exports = __webpack_public_path__ + "img/arrow-left-square.9185d063.svg";